
import { getUid, setUid, removeUid } from '@/store/cookies'
// import { getUid, setUid, removeUid } from '@/store/session'

import { loginPerson, loginGroup, loginUmpire, loginCoach } from '@/api/login'

const user = {
  state: {
    uid: '',
    apiUrl: process.env.BASE_API
  },

  mutations: {
    SET_UID: (state, uid) => {
      state.uid = uid
    },
    SET_API_URL: (state, api_url) => {
      state.apiUrl = api_url
    }
  },

  actions: {
    // 登录
    LoginPerson({ commit }, userInfo) {
      const msg = userInfo
      msg.mobile.trim()
      setUid('')
      return new Promise((resolve, reject) => {
        loginPerson(msg).then(response => {
          const id = parseInt(response.userId)
          setUid(id)
          commit('SET_UID', id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginGroup({ commit }, userInfo) {
      const msg = userInfo
      msg.userPo.mobile.trim()
      setUid('')
      return new Promise((resolve, reject) => {
        loginGroup(msg).then(response => {
          const id = parseInt(response.clubId)
          setUid(id)
          commit('SET_UID', id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginUmpire({ commit }, userInfo) {
      const msg = userInfo
      msg.mobile.trim()
      setUid('')
      return new Promise((resolve, reject) => {
        loginUmpire(msg).then(response => {
          const id = parseInt(response.userId)
          setUid(id)
          commit('SET_UID', id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginCoach({ commit }, userInfo) {
      const msg = userInfo
      msg.mobile.trim()
      setUid('')
      return new Promise((resolve, reject) => {
        loginCoach(msg).then(response => {
          const id = parseInt(response.userId)
          setUid(id)
          commit('SET_UID', id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 设置用户id
    SetUid({ commit }, id) {
      setUid(parseInt(id))
      commit('SET_UID', id)
    },
    // 获取用户id
    GetUid({ commit }) {
      const id = parseInt(getUid())
      setUid(id)
      commit('SET_UID', id)
      return id
    },

    // 登出
    LogOut({ commit, state }) {
      commit('SET_UID', '')
      removeUid()
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_UID', '')
        removeUid()
        resolve()
      })
    },
    SetAPIUrl({ commit }, api_url) {
      commit('SET_API_URL', api_url)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user.js